import api from './api';
import { normalizePortalUser } from './corporate/users';

export default {
    async getDataUser(userId, accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await api.get(`/user/${userId}`, { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            throw error;
        }
    },
    async getDataUserPortal(accessToken) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            };
            const response = await api.get(`portal/user`, { headers });
            return normalizePortalUser(response.data);
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            throw error;
        }
    },

    async getAllUser(accessToken, page = 0, perPage = 9999, search = '', status = 1, type = 3) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get(
                `/user?page=${page}&size=${perPage}&search=${search}&status=${status}&type=${type}`,
                {
                    method: 'GET',
                    headers,
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            // throw error;
        }
    },

    async CreateUser(accessToken, userData) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.post('/user', userData, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados da criação do usuário:', error);
            throw error;
        }
    },
    async EditUser(payload, accessToken, id) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.put(`/user/${id}`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao editar usuário:', error);
            throw error;
        }
    },
    async changePassword(payload, accessToken) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.post(`/user/change-password`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao alterar senha:', error);
            throw error;
        }
    },
    async resetPassword(accessToken, id) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.post(`/user/reset-password/${id}`, {
                method: 'POST',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao enviar email de reset de senha:', error);
            throw error;
        }
    },
    async importUsers(accessToken, file) {
        const form = new FormData();
        form.append('file', file);
        const response = await fetch(`${api.defaults.baseURL}/user/import`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${accessToken}` },
            body: form,
            credentials: 'include',
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
            const error = new Error(data.message || 'Erro ao importar usuários.');
            error.response = { status: response.status, data };
            throw error;
        }
        return data;
    },
};
